<template>
	<div ref="idPan" style="height:100%;">
		<popwin style="width:100%; height:100%;" :ctrl="ctrlWin"></popwin>

		<div style="flex: 0 0 auto; width:100%; height:50px;">
			<div class="SiftPanel">
				<div class="NButton DIVNoSelect" style="width:70px; margin-top:-1px; margin-left:10px;" @click="onTMAddClick">{{getLangText('新增')}}</div>

				<check style="height:30px; margin-right:10px; margin-left:20px;" :size="18" :grpName="'GrpRange'" :val="2" :capt="getLangText('私有')" :key="KeyPrivate" :checked="chkPrivate"></check>
				<check style="height:30px; margin-right:20px;"                   :size="18" :grpName="'GrpRange'" :val="1" :capt="getLangText('公共')" :key="KeyShare"   :checked="chkShare"></check>

				<div class="NButton DIVNoSelect" style="width:32px; height:32px; background:url(../static/images/op_fin.png); margin-top:-1px; margin-left:10px;" @click="onTMListClick"></div>
			</div>
		</div>

		<div ref="idTablePan" style="margin-top:6px; border:0px solid red; display:flex; align-items:center;">
			<ctable :ctrl="ctrlTable"></ctable>
		</div>
	</div>
</template>

<script>

import check      from '../cf/cck'
import ctable     from '../cf/ctable'
import popwin     from '../cf/popwin'

export default {
	name: 'tmList',
	components:{
		check, ctable, popwin
	},
	data () {
		return {
			chkPrivate: false,
			chkShare: false,
			KeyPrivate: 2000,
			KeyShare: 3000,
			ctrlWin:{                               // 弹出窗口控制属性
				w2: 400,
				h2: 240,
				captHeight: 40,                     // 标题栏高度
				captCont: "",                       // 标题
				vuepath: "/FrameBody/tmList/tmInfo",
				rcallFunc: this.onTMListClick,                 // 指定关闭弹出窗后需要执行的回调方法
			},
			ctrlTable: {                            // 表格控制参数
				headHeight: 50,                     // 表头行的高度
				dataHeight: 46,                     // 数据行的高度
				isCheck: false,                     // 第一列, 是否显示为复选框
				isSplit: false,                     // 固定列、数据列、操作列间是否有渐变分隔
				dataHeads:{                         // 表格表头定义
					head1:[                         // 固定列表头
						{ capt:'ID', width:100 },
					],
					head2:[                         // 数据列表头
						{ width:400, capt:this.getLangText('模板类型名称') },
						{ width:200, capt:this.getLangText('私有') },
						{ width:200, capt:'' },
					],
					head3:[                         // 操作列表头
						{ capt:this.getLangText('操作'), width:180 },
					],
				},
				datas:{ data1:[ ], data2:[ ], data3:[ ] },  // 表格数据定义
			},
		}
	},
	mounted: function(){
		if( !parseInt(this.login.userId) ) return;

		if( 0 <= (this.$route.query.findCustRange+"").indexOf("2") ) this.chkPrivate = true;
		if( 0 <= (this.$route.query.findCustRange+"").indexOf("1") ) this.chkShare = true;
		this.KeyPrivate++;
		this.KeyShare++;

		this.$refs["idTablePan"].style["height"] = (this.$refs["idPan"].offsetHeight - 56)+"px";

		this.ctrlTable.self.show();

		this.doTrade( "POST", ServAddr+"/api/cust/getCustInfo", this.getCustInfoOK, true, {custId: this.login.custId }, null );
	},
	computed:{

	},
	methods:{
		onResize: function( ){
			this.$refs["idTablePan"].style["height"] = (this.$refs["idPan"].offsetHeight - 56)+"px";

			this.childResize( this );
		},
		getCustInfoOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}

			if( data.body.custModelFlag==0 ) this.chkShare = false;
			this.KeyShare++;

			setTimeout( this.onTMListClick, 50 );
		},
		onTMListClick: function(){
			let body={ };

			let v=this.getCheckValuesByName( "GrpRange");
			if( v=="1,2" || v=="2,1" )
				 body.custRange = 3;
			else body.custRange = parseInt(v);

			this.doTrade( "POST", ServAddr+"/api/template/tmList", this.onTMListOK, true, body, null );
		},
		onTMListOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}

			this.ctrlTable.datas.data1=[];
			this.ctrlTable.datas.data2=[];
			this.ctrlTable.datas.data3=[];

			for(let i=0; i<data.body.tmList.length; i++ )
			{
				let item=data.body.tmList[i];
				this.ctrlTable.datas.data1.push([ item.tmId ]);

				let s="";
				if( item.tmCustId==0 ) s = this.getLangText("公共");
				if( item.tmCustId>0  ) s = this.getLangText("私有");
				this.ctrlTable.datas.data2.push([ item.tmName, s, ""] );

				let op1={capt: this.getLangText("编辑"), clk:null, param:{tmId: item.tmId, tmName:item.tmName}};
				let op2={capt: this.getLangText("删除"), clk:null, param:{tmId: item.tmId}};
				let op3={capt: this.getLangText("共享"), clk:null, param:{tmId: item.tmId}};

				if( item.tmCustId==0 )  // 共享模板, 只有系统管理员能够编辑
				{
					if( this.login.userId == gPlatUserId )
					{
						op2.clk = this.onTMDelClick;
						op1.clk = this.onTMModClick;
					}
				}
				else
				{
					op2.clk = this.onTMDelClick;
					if( item.tmCustId == gPlatCustId && this.login.userId == gPlatUserId )   // 只有利恩的模板并且是系统管理员才能操作共享
					{
						op3.clk = this.onTMShareClick;
					}
					op1.clk = this.onTMModClick;
				}

				if( this.login.custId == gPlatCustId )
					 this.ctrlTable.datas.data3.push([ [ op1, op2, op3 ] ]);
				else this.ctrlTable.datas.data3.push([ [ op1, op2 ] ]);
			}

			if( this.login.custId == gPlatCustId )
				 this.ctrlTable.dataHeads.head3[0].width = 180;
			else this.ctrlTable.dataHeads.head3[0].width = 130;

			this.ctrlTable.self.show();
		},
		onTMAddClick: function(){
			this.ctrlWin.captCont = LangText("新增模板类型");
			this.ctrlWin.info={ tmId:0, tmName:"" };
			this.ctrlWin.self.onShow();
		},
		/* 删除模板类型 */
		onTMDelClick: function( params ){
			this.appRoot.app.showDlgCfm( this.DialogType.War, LangText("警告"), LangText("确定要删除吗?"), "", {okFunc:this.doTMDel, okParam:params} );
		},
		doTMDel: function( params ){
			this.doTrade( "DELETE", ServAddr+"/api/template/tmDel/"+params.tmId, this.onTMDelOK, true, null, null );
		},
		onTMDelOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}
			this.onTMListClick();
		},
		/* 共享模板类型 */
		onTMShareClick: function( params ){
			this.appRoot.app.showDlgCfm( this.DialogType.War, LangText("警告"), LangText("确定共享吗?"), "", {okFunc:this.doTMShare, okParam:params} );
		},
		doTMShare: function( params ){
			let body={tmId:params.tmId};
			this.doTrade( "PUT", ServAddr+"/api/template/tmShare", this.onTMShareOK, true, body, null );
		},
		onTMShareOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}
			this.onTMListClick();
		},
		onTMModClick: function( params ){
			this.ctrlWin.captCont = LangText("修改模板类型");
			this.ctrlWin.info={ tmId: params.tmId, tmName: params.tmName };
			this.ctrlWin.self.onShow();
		},
	}
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// tmList.vue?2deb93c6